/** 등록 화면용 배송비 배분. 주문 결제 금액을 여기서 다시 계산하지 않는다. */

export interface PackQuoteInput {
  basisQty: number
  basisCost: number
  basisPrice: number
  shipFee: number
  shipMax: number
}

export interface PackQuote {
  qty: number
  units: number
  goodsCost: number
  ship: number
  unitShip: number
  totalCost: number
  unitCost: number
  recommended: number
  unitRecommended: number
}

export function wonShare(total: number, parts: number, qty: number): number {
  const base = Math.round(Number(total) || 0)
  const denom = Math.trunc(Number(parts) || 0)
  const count = Math.trunc(Number(qty) || 0)
  if (base === 0 || denom <= 0 || count <= 0) return 0
  return Math.round((base * count) / denom)
}

export function shipUnits(qty: number, maxQty: number): number {
  const count = Math.trunc(Number(qty) || 0)
  const max = Math.trunc(Number(maxQty) || 0)
  if (count <= 0 || max <= 0) return 0
  return Math.ceil(count / max)
}

export function actualShipFee(qty: number, shipFee: number, maxQty: number): number {
  const fee = Math.max(0, Math.round(Number(shipFee) || 0))
  return shipUnits(qty, maxQty) * fee
}

export function packQuoteReady(input: PackQuoteInput): boolean {
  const basisQty = Math.trunc(Number(input.basisQty) || 0)
  const basisCost = Math.round(Number(input.basisCost) || 0)
  const basisPrice = Math.round(Number(input.basisPrice) || 0)
  const shipFee = Math.round(Number(input.shipFee) || 0)
  const shipMax = Math.trunc(Number(input.shipMax) || 0)
  if (basisQty < 1 || basisCost <= 0 || basisPrice <= 0 || shipFee < 0) return false
  if (shipFee > 0 && shipMax < 1) return false
  return true
}

export function quotePack(qty: number, input: PackQuoteInput): PackQuote | null {
  const count = Math.trunc(Number(qty) || 0)
  if (!packQuoteReady(input) || count < 1) return null
  const shipMax = Math.max(1, Math.trunc(Number(input.shipMax) || 0) || Math.trunc(input.basisQty))
  const goodsCost = wonShare(input.basisCost, input.basisQty, count)
  const goodsSell = wonShare(input.basisPrice, input.basisQty, count)
  const ship = actualShipFee(count, input.shipFee, shipMax)
  const totalCost = goodsCost + ship
  const recommended = goodsSell + ship
  return {
    qty: count,
    units: shipUnits(count, shipMax),
    goodsCost,
    ship,
    unitShip: Math.round(ship / count),
    totalCost,
    unitCost: Math.round(totalCost / count),
    recommended,
    unitRecommended: Math.round(recommended / count),
  }
}

/** 배송 기준 수량까지. 10이면 3, 5, 10. 40이면 12, 20, 40. */
export function suggestPackQtys(maxQty: number): number[] {
  const max = Math.max(1, Math.trunc(Number(maxQty) || 0) || 1)
  const raw = [Math.round(max * 0.3), Math.round(max * 0.5), max]
  const unique = [...new Set(raw.map((qty) => Math.min(max, Math.max(1, qty))))]
  unique.sort((a, b) => a - b)
  return unique
}
